import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, ColumnLayout } from '@amzn/awsui-components-react';

import { LineVersion, ReceiptVersionRequest } from 'modules/audit/models';
import { ReceiptVersionList } from 'modules/audit/components/ReceiptVersionList/ReceiptVersionList';

export interface ConfirmVersionLineProps {
    lineVersion: LineVersion;
}

export const ConfirmVersionLine = (props: ConfirmVersionLineProps) => {
    const { lineVersion } = props;
    const { t } = useTranslation('purchase');

    function getModifiedRequests() {
        return lineVersion.receiptVersions.map(
            ({ modifiedReceiptAmount, modifiedReceiptTime }) =>
                new ReceiptVersionRequest(modifiedReceiptAmount, modifiedReceiptTime)
        );
    }

    return (
        <>
            <Box variant="strong">
                {t('version.poLine')} {lineVersion.lineNumber}: {lineVersion.lineDescription}
            </Box>
            <ColumnLayout columns={2}>
                <ReceiptVersionList requests={getModifiedRequests()} currency={lineVersion.currencyCode} />
            </ColumnLayout>
        </>
    );
};
